export type AuthMethod = 'facebook.com' | 'google.com';

export enum AdminRole {
  root = 'root',
  support_chat = 'support_chat',
  read_chats = 'read_chats',
  read_messages = 'read_messages',
  read_user_reports = 'read_user_reports',
  update_user_reports = 'update_user_reports',
  user_feedbacks = 'user_feedbacks',
  read_users = 'read_users',
  manage_users = 'manage_users',
  read_photos = 'read_photos',
  manage_photos = 'manage_photos',
  read_swipes = 'read_swipes',
  read_gifts = 'read_gifts',
  read_transactions = 'read_transactions',
};

export interface AdminUserData {
  id: string;
  name: string;
  email: string;
  roles: AdminRole[];
}